import { createAppAsyncThunk, logger, tap2mineReferralContract } from 'shared';
import { Address } from 'viem';

import { actionTypes } from '../action-types';
import { actions } from '../reducer';
import { selectTotalReferrals } from '../selectors';

import { getReferralLength } from './get-referral-length';

type ThunkData = {
  address: Address;
  page: number;
  limit?: number;
};

export const getUserReferrals = createAppAsyncThunk(
  actionTypes.GET_USER_REFERRALS,
  async ({ address, page, limit = 4 }: ThunkData, { dispatch, getState }) => {
    try {
      let maxLength = selectTotalReferrals(getState());

      if (maxLength === null) {
        maxLength = await dispatch(getReferralLength(address)).unwrap();
      }

      if (maxLength === 0) return null;

      const end = Math.min(page + limit, maxLength);

      const referrals = await tap2mineReferralContract.read.referrerInfo([address, BigInt(page), BigInt(end)]);

      const serializedData = referrals.map((ref) => ({
        referral: ref.referral,
        amount: ref.amount.toString(),
        TAP2MINEId: Number(ref.TAP2MINEId),
      }));

      dispatch(
        actions.updateUserReferrals({
          data: serializedData,
          hasNext: end !== maxLength,
        }),
      );

      return null;
    } catch (error) {
      logger(actionTypes.GET_USER_REFERRALS, error);

      throw error;
    }
  },
);
